






























































import Vue from 'vue';
import Component from 'vue-class-component';

// Store types
import {
    SystemsAction,
    SystemsGetter,
    SystemsFilters,
    SystemsFilterGroup,
    SystemsFilterOption,
} from '@/store/store.types';

// Button types
import { ButtonOptions } from '@/components/input/types';

// Modal
import Modal from '@/components/modal/Modal.vue';

/**
 *  Component for rendering the filters modal of the systems.
 */
@Component
export default class SystemFiltersModal extends Vue {

    public $refs!: {
        modal: Modal;
    };

    /**
     *  Holding the dirty state of the filters, which only
     *  get applied when the users hits the confirm button.
     */
    private dirtyFilters: SystemsFilters = {};

    /**
     *  Holding the options of the modal's buttons.
     */
    private actions: { [action: string]: ButtonOptions; } = {
        cancel: {
            title: 'Annuleer het aanpassen van de filters',
            content: 'Annuleren',
        },
        confirm: {
            title: 'Bevestig het aanpassen van de filters',
            content: 'Toepassen',
            disabled: false,
        },
    };

    /**
     *  Used to get the available filters from the store.
     */
    private get availableFilters(): Array<SystemsFilterGroup> {

        return this.$store.getters[SystemsGetter.FILTERS_AVAILABLE];

    }

    /**
     *  Used to get the filter's active state out of the store.
     */
    private get filtersActive(): boolean {

        return this.$store.getters[SystemsGetter.FILTER_ACTIVE];

    }

    /**
     *
     *  The modal is already rendered in the DOM before
     *  opening, so ensure to sync the dirties when created
     *  to prevent errors while rendering the modal.
     *
     *  (i) Because the v-for is based on the `availableFilters`
     *
     */
    public created(): void {

        this._syncDirties();

    }

    /**
     *  Used to open the filters modal.
     */
    public open(): void {

        this._syncDirties();

        this.$refs.modal.open();

    }

    /**
     *
     *  Used to get a unique key for the input component, used
     *  for both the v-for key as the input name.
     *
     *  @param availableFilter The filter to get the key/name for
     *  @param option The option to get the key/name for
     *
     *  @returns The unique key for the filter/value
     *
     */
    private getKeyName(availableFilter: SystemsFilterGroup, option: SystemsFilterOption): string {

        return `${ availableFilter.column }_${ option.label.toLowerCase() }`;

    }

    /**
     *  Used to apply the changes that the user made in the filters.
     */
    private apply(): void {

        this.$refs.modal.close();

        void this.$store.dispatch(SystemsAction.FILTERS_SET, this.dirtyFilters);

    }

    /**
     *  Used to cancel the changes in the dirties.
     */
    private cancel(): void {

        this.$refs.modal.close();

        this._syncDirties();

    }

    /**
     *
     *  Used to reset all the (dirty) filters.
     *
     *  (i) The user still needs to apply the changes though
     *
     */
    private reset(): void {

        for (const column of Object.keys(this.dirtyFilters)) {

            for (const value of Object.keys(this.dirtyFilters[column])) {

                Vue.set<false>(this.dirtyFilters[column], value, false);

            }

        }

    }

    /**
     *  Used to sync the dirties from the store state.
     */
    private _syncDirties(): void {

        this.dirtyFilters = JSON.parse(JSON.stringify(this.$store.getters[SystemsGetter.FILTER_STATE]));

    }

}
